import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { GoodsReceiptHistory } from '../goods-receipt-history.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-correct-order-dialog',
    templateUrl: './correct-order-dialog.component.html',
    styleUrls: ['./correct-order-dialog.component.scss'],
})
export class CorrectOrderDialogComponent implements OnInit {
    wareneingangshistorie: GoodsReceiptHistory;
    orderNoCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<CorrectOrderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        this.wareneingangshistorie = data.grh;
    }

    ngOnInit() {
        this.orderNoCtrl.setValue(this.wareneingangshistorie.bestell_nr);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    save() {
        const updateObject = {
            umbuchung_id: this.wareneingangshistorie.umbuchung_id,
            bestell_nr: this.orderNoCtrl.value,
        };

        this.api.updateGeneric(this.apiBaseUrl + 'wareneingang/update_bestellung.php', updateObject).subscribe(
            () => {
                this.messageService.infoMessage('Die Bestellung wurde erfolgreich korrigiert!');
                this.dialogRef.close(true);
            },
            error => {
                this.messageService.errorMessage('Fehler beim Korrigieren aufgetreten!', error);
                this.dialogRef.close(false);
            },
        );
    }
}
